import {Typography, Link} from '@deere/fuel-react';
import {show} from '../../redux/features/modal/modal.slice';
import {useDispatch} from 'react-redux';

export const BusinessLabel = () => {
    const dispatch = useDispatch();

    const handleClickOpen = () => {
        dispatch(show({
            name: 'countryModal',
            display: true
        }));
    };

    return (
        <Typography
            fontWeight='semibold'
            gutterBottom
            variant='h5'
        >
            {'You can contact our support team in the U.S. at 1-866-458-0400, at '}
            <Link
                href='#'
                onClick={handleClickOpen}
            >{'these other country specific phone numbers'}</Link>
            {', or the below form.'}
        </Typography>
    );
};
